import {useConcertoGenericQuery} from "@/hooks";
import {GenericTable} from "@dvrt/graphql-widgets";
import DeleteDeviceVariantButton from "./DeleteDeviceVariantButton";
import CreateDeviceVariantButton from "./CreateDeviceVariantButton";
import UpdateDeviceVariantButton from "./UpdateDeviceVariantButton";
import {DeviceVariantListFragmentDoc, DeviceVariantListFragment} from "./queries.generated";
import {defineMessages} from "react-intl";
import {commonTranslations} from "@/utils/translations";

export default () => {
    const query = useConcertoGenericQuery<DeviceVariantListFragment>("deviceVariants", DeviceVariantListFragmentDoc, {
        filtering: {
            argumentName: "filter",
            placeHolder: commonTranslations.filterPlaceholders.nameOrDomainName,
            idPrefix: "search-device-variants",
        },
        fetchPolicy: "cache-and-network",
        initialOrdering: ["name"],
    });

    return (
        <div style={{padding: "0 20px"}}>
            <GenericTable<DeviceVariantListFragment>
                query={query}
                labels={defineMessages({
                    id: {id: "unused", defaultMessage: "Unused"},
                    name: {id: "deviceVariants.name", defaultMessage: "Name"},
                    domain: {id: "unused", defaultMessage: "Unused"},
                    "domain.name": {id: "deviceVariants.domain.name", defaultMessage: "Domain name"},
                })}
                dataRenderers={{
                    name(value, _, __) {
                        return value;
                    },
                    domain: {
                        name: (value, _, rootRow) => {
                            if (rootRow.domain === null) return "";
                            return value;
                        },
                    },
                }}
                extraColumns={[
                    {
                        path: "actions",
                        label: null,
                        renderer: (row) => {
                            return [
                                <UpdateDeviceVariantButton
                                    name={row.name}
                                    domainName={row.domain?.name}
                                    id={row.id}
                                    onSuccess={() => query.refetch()}
                                    key="update"
                                />,
                                <DeleteDeviceVariantButton
                                    name={row.name}
                                    id={row.id}
                                    onSuccess={() => query.refetch()}
                                    key="delete"
                                />,
                            ];
                        },
                    },
                ]}
                createButton={<CreateDeviceVariantButton onSuccess={() => query.refetch()} />}
                orderableFields="all"
            />
        </div>
    );
};
